import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../lib/queryKeys'
import { getReservationDetail } from '../request/reservationApis'

import type { IReservation } from '../../model'

const useReservationDetailQuery = (reservationId: string) => {
  return useQuery<IReservation>({
    queryKey: QUERY_KEYS.RESERVATION.detail(reservationId),
    queryFn: () =>
      getReservationDetail({
        reservationId,
      }),
    enabled: !!reservationId,
    throwOnError: false,
  })
}

export default useReservationDetailQuery
